module.exports = "https://static-production.npmjs.com/1996fcfdf7ca81ea795f67f093d7f449.png";